import { render, staticRenderFns } from "./AnaliseLiberacaoLimite.vue?vue&type=template&id=ccc9bfd4"
import script from "./AnaliseLiberacaoLimite.vue?vue&type=script&lang=js"
export * from "./AnaliseLiberacaoLimite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports